const config = {
  app: {
    name: {
      short: 'EDD',
      long: 'Emergency Dental Direct'
    },
    version: '1.0.0',
    environment: process.env.VUE_APP_ENVIRONMENT
  },
  firebase: {
    collection: {
      users: 'users',
      dentists: 'dentists',
      appointments: 'appointments',
      availability: 'availability',
      enquiries: 'enquiries',
      tickets: 'tickets',
      requests: 'requests'
    }
  },
  stripe: {
    key: process.env.VUE_APP_STRIPE_PUBLIC_KEY
  },
  vgt: {
    pagination: {
      enabled: true,
      nextLabel: '',
      prevLabel: ''
    }
  },
  flex: {
    url: process.env.VUE_APP_FLEX_URL
  }
}

export default config
